import loadable from '@loadable/component';

export const WhattowatchSiteWrapper = loadable(
  () => import(/* webpackChunkName: "whattowatch-site" */ './WhattowatchSiteWrapper'),
);
